module.exports = __webpack_public_path__ + "static/mentor-kds-a770975bb98560358f510d554a0bdcf7.png";